import React, { Component } from "react";
import Chip from "@material-ui/core/Chip";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Grid from "@material-ui/core/Grid";
import Button from "components/CustomButtons/Button.jsx";
import Close from "@material-ui/icons/Close";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import Fab from "@material-ui/core/Fab";
import Tooltip from "@material-ui/core/Tooltip";
import { withStyles } from "@material-ui/core/styles";
import moment from "moment";
import ReactHtmlParser from "react-html-parser";
import { fetchWeather, fetchVoyageIMIS } from "../../api/portal";
import { withRouter } from "react-router-dom";

const NewTooltip = withStyles(() => ({
  tooltip: {
    backgroundColor: "#FFD700",
    color: "black",
    fontSize: 11
  }
}))(Tooltip);

class Tabinfo extends Component {
  constructor(props) {
    super(props);
    const { datanya } = this.props;
    this.state = {
      datanya: datanya,
      skalaBeaufort: "",
      alertVoyage: true,
      alertText: ""
    };
  }

  getNameshiptype = shiptype => {
    let shipTypeString;
    switch (shiptype) {
      case 1:
        shipTypeString = "Unspecified Ships";
        break;
      case 2:
        shipTypeString = "Fishing";
        break;
      case 3:
        shipTypeString = "Tugs & Special Craft";
        break;
      case 4:
        shipTypeString = "High Speed Craft";
        break;
      case 5:
        shipTypeString = "Pleasure Craft";
        break;
      case 6:
        shipTypeString = "Passenger Vessel";
        break;
      case 7:
        shipTypeString = "Cargo Vessel";
        break;
      case 8:
        shipTypeString = "Tanker";
        break;

      case 99:
        shipTypeString = "Pertamina";
        break;
      default:
        shipTypeString = "n/a";
        break;
    }

    return shipTypeString;
  };

  renderIpman = (title, value) => {
    if (value != null) {
      return (
        <TableRow hover>
          <TableCell component="th" scope="row">
            {" "}
            <small>{title}</small>
          </TableCell>
          <TableCell
            align="right"
            // style={{
            //   backgroundColor:
            //     this.state.alertVoyage != true ? "#FFD700" : "none"
            // }}
          >
            <small
              style={{
                display: "flex",
                justifyContent: "flex-end",
                color: this.state.alertVoyage != true ? "red" : "black"
              }}
            >
              {value != "" ? ReactHtmlParser(value) : "NO DATA"}
              <div
                hidden={this.state.alertVoyage}
                style={{ paddingLeft: "2px" }}
              >
                <NewTooltip title={this.state.alertText} aria-label="add">
                  <ErrorOutlineIcon
                    style={{ fontSize: "13px" }}
                    color="secondary"
                  />
                </NewTooltip>
              </div>
            </small>
          </TableCell>
        </TableRow>
      );
    }
  };

  renderNcorrection = (title, value) => {
    // if (value != null || value != "") {
    //   return (
    //     <TableRow hover>
    //       <TableCell component="th" scope="row">
    //         {" "}
    //         <small>{title}</small>
    //       </TableCell>
    //       <TableCell align="right">
    //         <small>-</small>
    //       </TableCell>
    //     </TableRow>
    //   );
    // } else {
    return (
      <TableRow hover>
        <TableCell component="th" scope="row">
          {" "}
          <small>{title}</small>
        </TableCell>
        <TableCell align="right">
          <small>{value != "" ? value : "NO DATA"}</small>
        </TableCell>
      </TableRow>
    );
    // }
  };

  getStatusName = status => {
    let statusString;
    switch (status) {
      case "..":
        statusString = "NOT ARRIVED";
        break;
      case "AR":
        statusString = "ARRIVED";
        break;
      case "SA":
        statusString = "SAILED/DEPARTED";
        break;
      default:
        statusString = "n/a";
        break;
    }
    return statusString;
  };

  getActivityName = activity => {
    let activityString;
    switch (activity) {
      case "L":
        activityString = "LOADING";
        break;
      case "D":
        activityString = "DISCHARGING";
        break;
      case "AR":
        activityString = "ARRIVED";
        break;
      case "SA":
        activityString = "SAILED/DEPARTED";
        break;
      case "..":
        activityString = "NOT ARRIVED";
        break;
      case "C":
        activityString = "COMMENCING";
        break;
      case "F":
        activityString = "FUELING AT ANCHORAGE";
        break;
      case "G":
        activityString = "FUELING BERTHING";
        break;
      case "I":
        activityString = "CANAL TRANSIT";
        break;
      case "M":
        activityString = "MULTI PURPOSE";
        break;
      case "P":
        activityString = "PASSING";
        break;
      case "O":
        activityString = "OTHER";
        break;
      case "R":
        activityString = "REPAIR";
        break;
      case "T":
        activityString = "TERMINATING";
        break;
      case "W":
        activityString = "WAITING NOMINATION";
        break;
      case "Y":
        activityString = "DELIVERY";
        break;
      case "Z":
        activityString = "REDELIVERY";
        break;
      default:
        activityString = "n/a";
        break;
    }
    return activityString;
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    let weather;
    let temp;
    let wind_speed;
    let wind_dir;

    let datax = nextProps.datanya;
    let str = "-";
    if (typeof nextProps.ship_id != "undefined") {
      if (nextProps.ship_id.length <= 8) {
        str = nextProps.ship_id;
      }
    }

    if (nextProps.rightPanel == true) {
      this.setState({
        destination: "",
        ipman_activity: "",
        dwt: "",
        ipman_eta: "",
        ipman_ata: "",
        status_name: "",
        ipman_container: "",
        ipman_container_value: "",
        vessel_status: "",
        alertVoyage: true,
        alertText: ""
      });
      fetchVoyageIMIS(datax.call_sign)
        .then(response => {
          if (response.data.Data.length > 0) {
            let dataVoyage = response.data.Data;
            dataVoyage.map(e => {
              if (e.Stage == "Commenced") {
                let port = e.PortCalls;
                let vessel = e.Vessel;

                let dateAlert = moment(e.CompletedAt).format(
                  "DD-MM-YYYY HH:mm:ss"
                );
                let today = moment().format("DD-MM-YYYY HH:mm:ss");

                if (dateAlert < today) {
                  this.setState({
                    alertVoyage: false,
                    alertText: "Data is not updated yet from IMIS"
                  });
                } else {
                  this.setState({
                    alertVoyage: true,
                    alertText: ""
                  });
                }

                let vesselStatus = e.TypeOperation;
                if (vesselStatus == "OVOV" || vesselStatus == "OVTO") {
                  this.setState({ vessel_status: "OWNED" });
                } else {
                  if (e.Delays.length > 0) {
                    let today = moment().format("DD-MM-YYYY HH:mm:ss");
                    let startdate = moment(e.Delays[0].DelayStart).format(
                      "DD-MM-YYYY HH:mm:ss"
                    );
                    let enddate = moment(e.Delays[0].DelayEnd).format(
                      "DD-MM-YYYY HH:mm:ss"
                    );

                    if (today >= startdate && today <= enddate) {
                      this.setState({ vessel_status: e.Delays[0].Activity });
                    } else {
                      this.setState({ vessel_status: "ON HIRE" });
                    }
                  } else {
                    this.setState({ vessel_status: "ON HIRE" });
                  }
                }

                let newdata = port[port.length - 1];
                if (newdata.Cargoes.length > 1) {
                  let cargoName = newdata.Cargoes.reduce((result, item) => {
                    return `${result}${item.Name}<br/>`;
                  }, "");
                  let cargoQty = newdata.Cargoes.reduce((result, item) => {
                    return `${result}${item.Quantity}<br/>`;
                  }, "");

                  this.setState({
                    ipman_container: cargoName,
                    ipman_container_value: cargoQty
                  });
                } else if (newdata.Cargoes.length >= 1) {
                  let cargoName = [];
                  let cargoQty = [];
                  newdata.Cargoes.map(e => {
                    cargoName.push(e.Name);
                    cargoQty.push(e.Quantity);
                  });
                  this.setState({
                    ipman_container: cargoName,
                    ipman_container_value: cargoQty
                  });
                } else {
                  this.setState({
                    ipman_container: "-",
                    ipman_container_value: "-"
                  });
                }

                this.setState({
                  destination: newdata.Name,
                  ipman_activity: this.getActivityName(newdata.Function),
                  dwt: vessel.DeadWeightTonnage,
                  ipman_eta: newdata.EstimatedTimeArrival,
                  ipman_ata: newdata.ActualTimeArrival,
                  status_name: this.getStatusName(newdata.Status)
                });
              }
            });
          } else {
            this.setState({
              destination: "NO DATA",
              ipman_activity: "NO DATA",
              dwt: "NO DATA",
              ipman_eta: "NO DATA",
              ipman_ata: "NO DATA",
              status_name: "NO DATA",
              ipman_container: "NO DATA",
              ipman_container_value: "NO DATA",
              vessel_status: "NO DATA",
              alertVoyage: false,
              alertText: "No Data from IMIS"
            });
          }
        })
        .catch(error => {
          console.log(error);
        });

      fetchWeather(datax.lon, datax.lat)
        .then(response => {
          let weather = "Unknown";
          let temp = "-";
          if (
            typeof response.data.data[0].weather.description !== "undefined"
          ) {
            weather = response.data.data[0].weather.description;
            temp = response.data.data[0].temp;
            wind_speed = response.data.data[0].wind_spd;
            wind_dir = response.data.data[0].wind_dir;
          }
          weather = weather;
          temp = temp;

          if (wind_speed < 1) {
            this.setState({ skalaBeaufort: "Calm" });
          } else if (wind_speed >= 1 && wind_speed <= 3) {
            this.setState({ skalaBeaufort: "Light Air" });
          } else if (wind_speed >= 4 && wind_speed <= 6) {
            this.setState({ skalaBeaufort: "Light Breeze" });
          } else if (wind_speed >= 7 && wind_speed <= 10) {
            this.setState({ skalaBeaufort: "Gentle Breeze" });
          } else if (wind_speed >= 11 && wind_speed <= 16) {
            this.setState({ skalaBeaufort: "Moderate Breeze" });
          } else if (wind_speed >= 17 && wind_speed <= 21) {
            this.setState({ skalaBeaufort: "Fresh Breeze" });
          } else if (wind_speed >= 22 && wind_speed <= 27) {
            this.setState({ skalaBeaufort: "Strong Breeze" });
          } else if (wind_speed >= 28 && wind_speed <= 33) {
            this.setState({ skalaBeaufort: "Near Gale" });
          } else if (wind_speed >= 34 && wind_speed <= 40) {
            this.setState({ skalaBeaufort: "Gale" });
          } else if (wind_speed >= 41 && wind_speed <= 47) {
            this.setState({ skalaBeaufort: "Strong Gale" });
          } else if (wind_speed >= 48 && wind_speed <= 55) {
            this.setState({ skalaBeaufort: "Storm" });
          } else if (wind_speed >= 56 && wind_speed <= 63) {
            this.setState({ skalaBeaufort: "Violent Storm" });
          } else if (wind_speed >= 64) {
            this.setState({ skalaBeaufort: "Hurricane" });
          }

          this.setState({
            weather: weather,
            temp: temp,
            wind_speed: wind_speed,
            wind_dir: wind_dir
          });
        })
        .catch(error => {
          console.log(error);
          // this.props.history.push("/pages/login#logout");
        });
    }

    let obname;

    if (datax.geofenceport_status == "1") {
      obname = datax.geofenceport_name;
    } else {
      obname = "NO DATA";
    }

    if (datax) {
      this.setState({
        baloonTitle: datax.baloonTitle,
        jenis: datax.jenis,
        call_sign: datax.call_sign,
        name: datax.name,
        hdg: datax.hdg,
        typenya: datax.typenya,
        geomtype: datax.geomtype,
        course: datax.course,
        elapsed: datax.elapsed,
        heading: datax.heading,
        lat: datax.lat,
        lon: datax.lon,
        weather: weather,
        temp: temp,
        shipname: datax.shipname,
        ship_id: datax.ship_id,
        ship_idx: str,
        type_img: datax.type_img,
        type_name: datax.type_name,
        geofenceport_name: obname,
        // vessel_status: datax.vessel_status,
        vessel_container: datax.vessel_container,
        remark: datax.remark,
        id: datax.id,
        speed: datax.speed,
        // status_name: datax.status_name,
        Tanggal: datax.Tanggal,
        Jam: datax.Jam,
        DateTime: datax.DateTime,
        Lintang: datax.Lintang,
        Bujur: datax.Bujur,
        Magnitude: datax.Magnitude,
        Kedalaman: datax.Kedalaman,
        Wilayah: datax.Wilayah,
        Potensi: datax.Potensi,
        Dirasakan: datax.Dirasakan,
        Coordinates: datax.Coordinates,
        Shakemap: datax.Shakemap,
        description: datax.description,
        address: datax.address,
        gid: datax.gid,
        dimensi: datax.dimensi,
        subdimensi: datax.subdimensi,
        district: datax.district,
        subdistrict: datax.subdistrict,
        category: datax.category,
        //destination: datax.destination,
        rot: datax.rot,
        width: datax.width,
        length: datax.length,
        flag: datax.flag,
        date_created: datax.date_created,
        // dwt: datax.dwt,
        eta: datax.eta,
        openAlert: false,
        openAlertDeparture: false,
        wind_speep: wind_speed,
        wind_dir: wind_dir,
        //ipman_container_value: datax.ipman_container_value,
        //ipman_activity: datax.ipman_activity,
        ipman_plant: datax.ipman_plant,
        // ipman_eta: datax.ipman_eta,
        // ipman_ata: datax.ipman_ata,
        ipman_remark: datax.ipman_remark,
        // ipman_container: datax.ipman_container,
        source: datax.source
      });
      // console.log(datax)
    }
  }

  render() {
    return (
      <Grid xs={12} sm={12} md={12} style={{ padding: 10 }}>
        <Table size="small" aria-label="a dense table">
          <TableBody striped={true}>
            <TableRow hover>
              <TableCell component="th" scope="row">
                {" "}
                <small>SOURCE </small>
              </TableCell>
              <TableCell align="right">
                <small>{this.state.source} </small>
              </TableCell>
            </TableRow>
            <TableRow hover>
              <TableCell component="th" scope="row">
                {" "}
                <small>SHIP ID/CALLSIGN </small>
              </TableCell>
              <TableCell align="right">
                <small>
                  {this.state.ship_id}/{this.state.call_sign}{" "}
                </small>
              </TableCell>
            </TableRow>
            <TableRow hover>
              <TableCell component="th" scope="row">
                {" "}
                <small>FLAG</small>
              </TableCell>
              <TableCell align="right">
                <small style={{ textTransform: "uppercase" }}>
                  {this.state.flag}{" "}
                </small>
              </TableCell>
            </TableRow>
            <TableRow hover>
              <TableCell component="th" scope="row">
                {" "}
                <small>LAST SEEN</small>
              </TableCell>
              <TableCell align="right">
                <small>
                  {moment(this.state.date_created).format(
                    "DD-MM-YYYY HH:mm:ss"
                  )}{" "}
                  WIB{" "}
                </small>
              </TableCell>
            </TableRow>
            <TableRow hover>
              <TableCell component="th" scope="row">
                {" "}
                <small>SPEED</small>
              </TableCell>
              <TableCell align="right">
                <small>{parseInt(this.state.speed).toFixed(0)} knot </small>
              </TableCell>
            </TableRow>

            <TableRow hover>
              <TableCell component="th" scope="row">
                {" "}
                <small>DESTINATION</small>
              </TableCell>
              <TableCell
                align="right"
                // style={{
                //   backgroundColor:
                //     this.state.alertVoyage != true ? "#FFD700" : "none"
                // }}
              >
                <small
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    color: this.state.alertVoyage != true ? "red" : "black"
                  }}
                >
                  {this.state.destination != ""
                    ? this.state.destination
                    : "NO DATA"}
                  <div
                    hidden={this.state.alertVoyage}
                    style={{ paddingLeft: "2px" }}
                  >
                    <NewTooltip title={this.state.alertText} aria-label="add">
                      <ErrorOutlineIcon
                        style={{ fontSize: "13px" }}
                        color="secondary"
                      />
                    </NewTooltip>
                  </div>
                </small>
              </TableCell>
            </TableRow>

            <TableRow hover>
              <TableCell component="th" scope="row">
                {" "}
                <small>OB AREA </small>
              </TableCell>
              <TableCell align="right">
                <small>{this.state.geofenceport_status} </small>
                <small style={{ textTransform: "uppercase" }}>
                  {this.state.geofenceport_name}{" "}
                </small>
              </TableCell>
            </TableRow>
            <TableRow hover>
              <TableCell component="th" scope="row">
                {" "}
                <small>WEATHER/TEMP</small>
              </TableCell>
              <TableCell align="right">
                <small style={{ textTransform: "uppercase" }}>
                  {this.state.weather}/{this.state.temp}
                  ºC{" "}
                </small>
              </TableCell>
            </TableRow>
            <TableRow hover>
              <TableCell component="th" scope="row">
                {" "}
                <small>WIND SPEED</small>
              </TableCell>
              <TableCell align="right">
                <small style={{ textTransform: "uppercase" }}>
                  {this.state.wind_speed} knot, {this.state.skalaBeaufort}
                </small>
              </TableCell>
            </TableRow>
            <TableRow hover>
              <TableCell component="th" scope="row">
                {" "}
                <small>WIND DIR</small>
              </TableCell>
              <TableCell align="right">
                <small>{this.state.wind_dir}º </small>
              </TableCell>
            </TableRow>
            <TableRow hover>
              <TableCell component="th" scope="row">
                {" "}
                <small>STATUS</small>
              </TableCell>
              <TableCell
                align="right"
                // style={{
                //   backgroundColor:
                //     this.state.alertVoyage != true ? "#FFD700" : "none"
                // }}
              >
                <small
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    color: this.state.alertVoyage != true ? "red" : "black"
                  }}
                >
                  {this.state.status_name == ""
                    ? "NO DATA"
                    : this.state.status_name == "undefined"
                      ? "NO DATA"
                      : this.state.status_name}

                  <div
                    hidden={this.state.alertVoyage}
                    style={{ paddingLeft: "2px" }}
                  >
                    <NewTooltip title={this.state.alertText} aria-label="add">
                      <ErrorOutlineIcon
                        style={{ fontSize: "13px" }}
                        color="secondary"
                      />
                    </NewTooltip>
                  </div>
                </small>
              </TableCell>
            </TableRow>
            <TableRow hover>
              <TableCell component="th" scope="row">
                {" "}
                <small>VESSEL STATUS</small>
              </TableCell>
              <TableCell align="right">
                <small>
                  {this.state.vessel_status != ""
                    ? this.state.vessel_status
                    : "NO DATA"}
                </small>
              </TableCell>
            </TableRow>
            {/* <div hidden={this.state.vessel_status == "off hire" ? true : false}> */}
            {this.state.vessel_status != "OFF HIRE"
              ? this.renderIpman("CARGO", this.state.ipman_container)
              : null}
            {this.state.vessel_status != "OFF HIRE"
              ? this.renderIpman("CARGO QTY", this.state.ipman_container_value)
              : null}
            {this.state.vessel_status != "OFF HIRE"
              ? this.renderIpman("ACTIVITY", this.state.ipman_activity)
              : null}
            {/* <TableRow hover>
              <TableCell component="th" scope="row">
                {" "}
                <small>REMARK</small>
              </TableCell>
              <TableCell align="right">
                <small>{this.state.ipman_remark}</small>
              </TableCell>
            </TableRow> */}
            {/* {this.renderIpman("PLAN", this.state.ipman_plant)}
            {this.renderNcorrection("ELAPSED", this.state.elapsed)}
            {this.renderNcorrection("HEADING", this.state.heading)} */}
            {this.state.vessel_status != "OFF HIRE" ? (
              <TableRow hover>
                <TableCell component="th" scope="row">
                  {" "}
                  <small>TYPE</small>
                </TableCell>
                <TableCell align="right">
                  <small style={{ textTransform: "uppercase" }}>
                    {this.getNameshiptype(this.state.typenya)}
                  </small>
                </TableCell>
              </TableRow>
            ) : null}

            {this.state.vessel_status != "OFF HIRE" ? (
              <TableRow hover>
                <TableCell component="th" scope="row">
                  {" "}
                  <small>LATITUDE</small>
                </TableCell>
                <TableCell align="right">
                  <small>{parseFloat(this.state.lat).toFixed(4)}º</small>
                </TableCell>
              </TableRow>
            ) : null}

            {this.state.vessel_status != "OFF HIRE" ? (
              <TableRow hover>
                <TableCell component="th" scope="row">
                  {" "}
                  <small>LONGITUDE</small>
                </TableCell>
                <TableCell align="right">
                  <small>{parseFloat(this.state.lon).toFixed(4)}º</small>
                </TableCell>
              </TableRow>
            ) : null}

            {this.state.vessel_status != "OFF HIRE" ? (
              <TableRow hover>
                <TableCell component="th" scope="row">
                  {" "}
                  <small>ETA</small>
                </TableCell>
                <TableCell
                  align="right"
                  // style={{
                  //   backgroundColor:
                  //     this.state.alertVoyage != true ? "#FFD700" : "none"
                  // }}
                >
                  <small
                    style={{
                      display: "flex",
                      justifyContent: "flex-end",
                      color: this.state.alertVoyage != true ? "red" : "black"
                    }}
                  >
                    {this.state.ipman_eta != null &&
                    this.state.ipman_eta != "" &&
                    this.state.ipman_eta != "-" &&
                    this.state.ipman_eta != "NO DATA"
                      ? moment(this.state.ipman_eta)
                          .add(7, "hours")
                          .format("DD/MM/YYYY HH:mm:ss") +
                        " " +
                        "WIB"
                      : "NO DATA"}
                    <div
                      hidden={this.state.alertVoyage}
                      style={{ paddingLeft: "2px" }}
                    >
                      <NewTooltip title={this.state.alertText} aria-label="add">
                        <ErrorOutlineIcon
                          style={{ fontSize: "13px" }}
                          color="secondary"
                        />
                      </NewTooltip>
                    </div>
                  </small>
                </TableCell>
              </TableRow>
            ) : null}
            {/* <TableRow hover>
              <TableCell component="th" scope="row">
                {" "}
                <small>ETA (GPS ROUTING)</small>
              </TableCell>
              <TableCell align="right">
                <small> 
                {this.state.eta ? moment(this.state.date_created).add(this.state.eta, 'hours').format("DD/MM/YYYY HH:mm:ss") : this.state.eta}</small>
              </TableCell>
            </TableRow> */}
            {this.state.vessel_status != "OFF HIRE" ? (
              <TableRow hover>
                <TableCell component="th" scope="row">
                  {" "}
                  <small>ATA</small>
                </TableCell>
                <TableCell
                  align="right"
                  // style={{
                  //   backgroundColor:
                  //     this.state.alertVoyage != true ? "#FFD700" : "none"
                  // }}
                >
                  <small
                    style={{
                      display: "flex",
                      justifyContent: "flex-end",
                      color: this.state.alertVoyage != true ? "red" : "black"
                    }}
                  >
                    {this.state.ipman_ata != null &&
                    this.state.ipman_ata != "" &&
                    this.state.ipman_ata != "-" &&
                    this.state.ipman_ata != "NO DATA"
                      ? moment(this.state.ipman_ata)
                          .add(7, "hours")
                          .format("DD/MM/YYYY HH:mm:ss") +
                        " " +
                        "WIB"
                      : "NO DATA"}
                    <div
                      hidden={this.state.alertVoyage}
                      style={{ paddingLeft: "2px" }}
                    >
                      <NewTooltip title={this.state.alertText} aria-label="add">
                        <ErrorOutlineIcon
                          style={{ fontSize: "13px" }}
                          color="secondary"
                        />
                      </NewTooltip>
                    </div>
                  </small>
                </TableCell>
              </TableRow>
            ) : null}
            {this.state.vessel_status != "OFF HIRE"
              ? this.renderNcorrection("DWT", this.state.dwt)
              : null}
            {/* {this.renderNcorrection("WIDTH", this.state.width)}
            {this.renderNcorrection("LENGTH", this.state.length)} */}
            {/* <TableRow hover>
              <TableCell component="th" scope="row">
                {" "}
                <small>DWT</small>
              </TableCell>
              <TableCell align="right">
                <small>{this.state.dwt} </small>
              </TableCell>
            </TableRow>
            <TableRow hover>
              <TableCell component="th" scope="row">
                {" "}
                <small>WIDTH</small>
              </TableCell>
              <TableCell align="right">
                <small>{this.state.width} </small>
              </TableCell>
            </TableRow>
            <TableRow hover>
              <TableCell component="th" scope="row">
                {" "}
                <small>LENGTH</small>
              </TableCell>
              <TableCell align="right">
                <small>{this.state.length} </small>
              </TableCell>
            </TableRow>*/}
            <TableRow style={{ height: 50 }} />
            {/* </div> */}
          </TableBody>
        </Table>
      </Grid>
    );
  }
}

function mapStateToProps(state) {
  return {
    blocking: state.loader,
    basemap: state.basemap,
    rightPanel: state.rightPanel
  };
}

export default withRouter(
  connect(
    mapStateToProps,
    {}
  )(Tabinfo)
);
